/**
 * The AI panel's scope line: "Scope: as of 7/10/2026 · all attorneys · 40 rows".
 *
 * From the Figma (frame 110:11804). It is the honest counterpart to the panel's
 * disclaimer: the model was given THIS filtered view, not the whole ledger, and on
 * a financial report the difference between "all attorneys" and one attorney is the
 * difference between a right and a wrong number.
 *
 * A shared `.js` util rather than an export from `ReportAiSummary.jsx`, for two
 * reasons: exporting a non-component from a component file breaks fast refresh
 * (`react-hooks`/`react-refresh/only-export-components`, and CLAUDE.md says to put
 * shared helpers in a `*.js`), and both chrome hosts need it — two hosts formatting
 * the same sentence slightly differently is exactly the drift this refresh keeps
 * undoing.
 *
 * Returns '' when there is nothing honest to say, so the panel omits the line
 * rather than printing a bare "Scope:".
 */
export const aiScopeLine = (filtersSummary, rowCount) => {
  const parts = []
  if (filtersSummary) parts.push(filtersSummary)
  if (Number.isFinite(rowCount) && rowCount > 0) parts.push(`${rowCount.toLocaleString()} rows`)
  return parts.length ? `Scope: ${parts.join(' · ')}` : ''
}

export default aiScopeLine
